import { PlatformCompat } from "@huyafed/huya-kiwi";

export const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

const ua = navigator?.userAgent?.toLowerCase?.() || "";

export const isPC = /huya-pc/.test(ua);

export const isPCAnchor = /hyanchor/.test(ua);

export const isZSApp = /huya-zs/.test(ua);

export const isHarmonyOSMobile =
  /Harmony/i.test(navigator.userAgent) && /Mobile|Tablet/i.test(navigator.userAgent);

export const isHUYALiveHarmonyApp = /hmos_kiwi/i.test(navigator.userAgent);

export const isiPad =
  navigator.userAgent.match(/(iPad)/) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isMobile =
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    navigator.userAgent,
  ) ||
  isHarmonyOSMobile ||
  isiPad;

const hasHUYAKeyWord = navigator.userAgent.trim().split(" ").includes("huya");

export const isHUYAApp = isMobile && hasHUYAKeyWord;

export const isHUYAAdr = isHUYAApp && !isIOS;

export const getBrowserVersion = () => {
  var userAgent = navigator.userAgent;
  var chromeRegex = /Chrome\/([0-9.]+)/;
  var matches = userAgent.match(chromeRegex);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return "";
};

export const versionCompare = (version1, version2) => {
  var v1 = version1.split(".");
  var v2 = version2.split(".");
  for (var i = 0; i < Math.max(v1.length, v2.length); i++) {
    var num1 = parseInt(v1[i]) || 0;
    var num2 = parseInt(v2[i]) || 0;
    if (num1 < num2) return -1;
    else if (num1 > num2) return 1;
  }
  return 0;
};

export const isMiniBlinkWebViewInPC = (() => {
  const MIN_VERSION = "88";
  const browserVersion = getBrowserVersion();
  const isInMiniBlinkWebView = /huya-pc/gi.test(navigator.userAgent);
  const isVersionLess = versionCompare(browserVersion, MIN_VERSION) === -1;
  return isVersionLess && isInMiniBlinkWebView;
})();

type TCheckItem = "kiwi" | "pitaya" | "zs" | "pc_exe" | "pc_anchor";

export async function checkIs(client: TCheckItem): Promise<boolean>;
export async function checkIs(client: TCheckItem[]): Promise<boolean>;
export async function checkIs(client: TCheckItem | TCheckItem[]) {
  const platform = await PlatformCompat.getPlatformOS();
  const checkItem = (item: TCheckItem) =>
    item === "pc_exe" ? platform === "pc_exe" || platform === "pc_exe_external" : platform === item;
  return Array.isArray(client) ? client.some(item => checkItem(item)) : checkItem(client);
}
